import { useQuery } from '@tanstack/react-query'
import type { FloorOutput } from 'types/api'
import { apiClient } from '../api-client'
import { SNA_PREFIX } from '@services/utils'

export const floorsQueryKey = ['floors']

export function useFloors() {
  async function getFloors() {
    const response = await apiClient.get<FloorOutput[]>(SNA_PREFIX + `floors`)

    return response.data
  }

  return useQuery({
    queryFn: getFloors,
    queryKey: [...floorsQueryKey]
  })
}
